import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  CanActivateFn,
} from "@angular/router";
import { Observable } from "rxjs";
import { LocalStorageService } from "../_services/localStorage.service";
import { ModalController } from "@ionic/angular";
import { LoginPage } from "../pages/auth/login/login.page";

// LoginPage
@Injectable({
  providedIn: "root",
})
class GuestPermession {
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const acceptGuest = next.data["guest"] as boolean;
    const acceptInput = next.data["connected"] as boolean;
    const acceptconnected = acceptInput != null ? acceptInput : true;

    const userData = this.localStorageService.getUserData().client;
    const roles = userData && userData.roles[0];
    let passable = (userData || acceptGuest) && acceptconnected ? true : false;
    const url = state.url;
    const loginRoute = url == "/login";


    if (passable) {
      if (loginRoute && !acceptconnected && userData) {
        this.goHome(roles);
      } else {
        return true;
      }
    } else {
      if (loginRoute && userData) {
        this.goHome(roles);
      } else {
        if ((!loginRoute && userData) || (loginRoute && !userData)) {
          return true;
        } else {
          this.router.navigate(["/login"]);
        }
      }
    }
    return false;
  }
  goHome(roles: string) {
    if (roles == "prestataire") {
      this.router.navigate(["/prestataire"]);
    } else {
      this.router.navigate(["/particulier"]);
    }
  }
}

export const Guest: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
):
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  return inject(GuestPermession).canActivate(next, state);
};
